import useNavigation from "./useNavigation";

function useBack() {
  let navigation = useNavigation();

  return function back() {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      // fallback to homepage
      navigation.navigate("Home");
    }
  };
}

export default useBack;
